import {defineStore} from 'pinia'
import { useStorage } from '@vueuse/core' // for simply using localstorage

export const useUserPreferenceStore = defineStore("userPreferenceStore", {
    state: () => {
        return {
            coi: useStorage("userPreferenceCoi",
                {
                    lightMode: false,
                    personalPerPage : null,
                    orderBy : null,
                    activeQuery: null,
                    isMaster: false,
                },
                localStorage,
                {
                    mergeDefaults: true
                }
            ),
            inventory: useStorage("userPreferenceInventory",
                {
                    currentPage: null,
                    perPage: null,
                    searchFilter: null,
                },
                localStorage,
                {
                    mergeDefaults: true
                }
            )

        }
    },
    getters: {
        // toggleCustomerOrderLightInfoMode : (state) => {
        //     return !state.lightMode
        // }
    },
    actions: {
        updateCoi(key, value){
            if(this.coi.hasOwnProperty(key)){
                this.coi[key] = value;
            }
        },
        updateInventory(key, value){
            if(this.inventory.hasOwnProperty(key)){
                this.inventory[key] = value;
            }
        },
        toggleLightMode(){
            this.coi.lightMode =  !this.coi.lightMode;
        }
    },    

});